/*
 * This file is unchanged, except for removing eslint comments
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useBackButton", {
    enumerable: true,
    get: function() {
        return useBackButton;
    }
});
function useBackButton(_) {
// No-op
// BackHandler is not available on web
}

//# sourceMappingURL=useBackButton.js.map
